import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';
import { hash } from 'rsvp';

import { breadcrumb } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class AboutRoute extends Route {
  @service announcements;
  @service keywords;
  @service store;
  @service uiPages;

  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: 'Learn more about RISE and access release notes about changes '
            + 'to the RISE system.',
        },
      },
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(
            true,
            this.keywords.strings['data-keywords'],
            this.keywords.strings['about-keywords'],
          ),
        },
      },
    ];
  }

  @breadcrumb crumb = 'About RISE';

  model() {
    return hash({
      about: this.uiPages.get('about-rise'),
      announcements: this.announcements.fetch(),
    });
  }
}
